import {Directive, ElementRef} from "@angular/core";

@Directive({
  selector: 'intPortalSlotViewPort'
})
export class IntPortalSlotViewportContainerDirective {
  constructor(
    private readonly elementRef: ElementRef
  ) {
  }
}
